/**
 * Route: /class-schedules/:classId
 *
 * Unified with /check-staff/classes/list/:id — both routes now render the
 * SAME premium ClassDetailPage component so the layout, cards, sidebar and
 * behaviour stay identical regardless of entry point. Route-specific concerns
 * (return_url from team-history's ClassSchedules tab, the fallback back
 * target, the URL param name) are passed as props.
 *
 * The old bespoke "ClassScheduleDetailsPage" JSX/cards were removed as part
 * of the class-details UI unification.
 */
import React from "react";
import ClassDetailPage from "../Classes/CheckStaff/ClassDetailPage";

const ClassScheduleDetailsRoute: React.FC = () => (
  <ClassDetailPage paramName="classId" fallbackBackUrl="/class-schedules" />
);

export default ClassScheduleDetailsRoute;
